import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497cc2f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-background" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { onMounted } from "vue";
import { useAuth } from "@/use/useAuth";
import { useAsync } from "@/use/useAsync";
import { initBridge } from "@/api/interceptors";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { fetchCurrentUser } = useAuth();
const router = useRouter();

const fetchData = useAsync(async () => {
  const { platform, initData } = await initBridge();

  if (initData && ((process.env.VUE_APP_FEATURE_TELEGRAM === "true" && platform === "telegram") || platform === "max")) {
    await router.replace({ name: "web-app-choose" });
    return;
  }

  if (initData && platform === "vk") {
    await router.replace({ name: "login" });
    return;
  }

  try {
    await fetchCurrentUser();
  } catch {
    await router.replace({ name: "login" });
  }
});

onMounted(fetchData.execute);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(fetchData).isPending.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ]))
}
}

})